module.exports = __webpack_public_path__ + "static/media/MyPSize_Photo.efce5464.jpg";